const DOMAIN_NAME = 'tipps.'

export { DOMAIN_NAME }
export default DOMAIN_NAME
